import { render, staticRenderFns } from "./user-assets.vue?vue&type=template&id=74b6d28e&"
import script from "./user-assets.vue?vue&type=script&lang=js&"
export * from "./user-assets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports